import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TasksPage } from '@/features/plan/tasks-page';

const searchSchema = z.object({
  task: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/plan/tasks')({
  validateSearch: searchSchema,
  component: TasksRoute,
});

function TasksRoute() {
  const { projectId } = Route.useParams();
  const { task } = Route.useSearch();
  return <TasksPage projectId={projectId} taskId={task} />;
}
